module.exports = __webpack_public_path__ + "img/h5_banner02.fc0102d8.webp";